import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { IconSharedComponent } from './icon.component';
import { TransformSportToIconNamePipe } from '../../../shared/pipe/sportToIconName/sport-to-icon-name.pipe';

@NgModule({
    declarations: [
        IconSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        IconSharedComponent
    ],
    providers: [
        TransformSportToIconNamePipe
    ]
})

export class IconSharedModule { }
